import { RowEditAndDelete } from 'components/icons/RowEditAndDelete';

export const columnsDataCarteiraForm = [
	{
		Header: 'Carteira de Pedido é Ruim?',
		accessor: 'ruim',
		type: 'toggle',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Competência',
		accessor: 'competencia',
		type: 'date',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Canal de Venda',
		accessor: 'canalVenda',
		type: 'relation',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Cliente',
		accessor: 'cliente',
		type: 'autocomplete',
		createable: true,
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Familia',
		accessor: 'familia',
		type: 'relation',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Cód. Produto',
		accessor: 'codigoProduto',
		type: 'relation',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Quantidade',
		accessor: 'quantidade',
		type: 'money',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Receita Bruta',
		accessor: 'receitaBruta',
		type: 'money',
		optional: true,
		filter: 'includesIgnoreCase',
	},
];

export const columnsDataCarteira = [
	{
		Header: ' ',
		accessor: 'CheckBox',
		disableSortBy: true,
		type: 'checkBox',
		filter: false,
	},
	{
		Header: 'Cód.',
		accessor: 'codigoCarteiraPedido',
		type: 'number',
		optional: true,
		filter: 'includesIgnoreCase',
		hover: 'Código da Carteira de Pedido',
	},
	{
		Header: 'Seq.',
		accessor: 'sequenciaCodigoCarteiraPedido',
		type: 'number',
		optional: true,
		filter: 'includesIgnoreCase',
		hover: 'Sequência do Código da Carteira de Pedido',
	},
	{
		Header: 'Competência',
		accessor: 'competencia',
		type: 'date',
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Ruim',
		accessor: 'ruim',
		filter: false,
		type: 'switch-actionable',
		helper: true,
		helperText:
			'Uma carteira boa de pedidos consiste em pedidos que serão faturados no mês. Enquanto isso, uma carteira ruim de pedidos envolve pedidos que possuem falta de crédito ou indisponibilidade de MP.',
	},
	{
		Header: 'Quantidade',
		accessor: 'quantidade',
		type: 'text',
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Receita Bruta',
		accessor: 'receitaBruta',
		type: 'text',
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Familia',
		accessor: 'familia',
		type: 'nullableTag',
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Subfamília',
		accessor: 'subFamilia',
		type: 'nullableTag',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Modelo',
		accessor: 'modelo',
		type: 'nullableTag',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Nome do Produto',
		accessor: 'nomeProduto',
		type: 'text',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Cód. Produto',
		accessor: 'codigoProduto',
		type: 'relation',
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Mercado',
		accessor: 'mercado',
		type: 'nullableTag',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Canal de Venda',
		accessor: 'canalVenda',
		type: 'nullableTag',
		createable: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Força de Venda',
		accessor: 'forcaVenda',
		type: 'nullableTag',
		createable: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Zona de Venda',
		accessor: 'zonaVenda',
		type: 'nullableTag',
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Membro',
		accessor: 'membro',
		type: 'nullableTag',
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Razão Social',
		accessor: 'cliente',
		type: 'nullableTag',
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'CNPJ/CPF/ID',
		accessor: 'cnpjCpfId',
		type: 'nullableTag',
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Faturado',
		accessor: 'faturado',
		filter: false,
		type: 'toggleAndEditModal',
	},
	{
		Header: 'Data Registro',
		accessor: 'dataRegistro',
		type: 'date',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Cód. Hierarquia',
		accessor: 'code',
		type: 'relation',
		filter: 'includesIgnoreCase',
	},
	{
		Header: ' ',
		type: 'jsx',
		accessor: 'button',
		filter: false,
		jsx: RowEditAndDelete,
	},
];
